
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6e06ca1a&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AmazonRegionConnect.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AmazonRegionConnect.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6e06ca1a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AmazonRegionConnect.vue"),
  /* scopeId */
  "data-v-6e06ca1a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonRegionConnect.vue
// module id = 644
// module chunks = 2